import { CommandBarButton, Stack } from "@fluentui/react";
import styles from './NewChat.module.scss';

interface NewChatProps {
    onClick: () => void;
}

const NewChat: React.FC<NewChatProps> = ({ onClick }) => {
    return (

        <Stack tokens={{ childrenGap: 10 }} horizontalAlign="end" className={styles.newChatStack}>
            <CommandBarButton
                iconProps={{
                    iconName: 'Add',
                    styles: {
                        root: { fontSize: 12, alignContent: 'center' }
                    }
                }}
                className={styles.newChatButton}
                text="New Chat"
                onClick={onClick}
            />
        </Stack>
    );

};

export default NewChat;
